import React, { FC } from "react";
import { Employees, PrivateCalendars, Rooms } from ".";
import { ICalendarForFilter, IRoom, IUser } from "../../../utils";
import { IColor } from "../../../utils/types/colors";
import { observer } from "mobx-react-lite";

interface BlocksProps {
  isModerator: boolean;
  roomsLoading: boolean;
  rooms: IRoom[];
  selectRoomCabinetNumber: number;
  onChooseRoom: (roomNumber: number) => void;
  onChooseAllRooms: () => void;
  showAllRoomsMeetings: boolean;
  isMembersLoading: boolean;
  selectEmployeeId: number;
  members: IUser[];
  onChooseEmployee: (id: number) => void;
  isCalendarsLoading: boolean
  privateCalendars: ICalendarForFilter[];
  setCheckedCalendar: (calendar: ICalendarForFilter) => void;
  getColorByName: (colorName: string) => IColor;
}

export const Blocks: FC<BlocksProps> = observer(({
  isModerator, roomsLoading, rooms, selectRoomCabinetNumber, showAllRoomsMeetings,
  isMembersLoading, selectEmployeeId, members, isCalendarsLoading, privateCalendars,
  onChooseRoom, onChooseAllRooms, onChooseEmployee, setCheckedCalendar, getColorByName
}) => {
  return (
    <>
      {isModerator 
        ? (
          <Rooms
            rooms={rooms}
            selectRoomNumber={selectRoomCabinetNumber}
            onChooseRoom={onChooseRoom}
            onChooseAllRooms={onChooseAllRooms}
            allRoomsSelected={showAllRoomsMeetings}
            isLoading={roomsLoading}
          />
        )
        : (
          <PrivateCalendars
            calendars={privateCalendars}
            onCheckedCalendar={setCheckedCalendar}
            getHexCodefromColorName={getColorByName} 
            isLoading={isCalendarsLoading}
          />
        )
      }

      <Employees
        selectEmployeeId={selectEmployeeId}
        users={members}
        onChooseEmployee={onChooseEmployee} 
        isLoading={isMembersLoading}
      />
      
      {!isModerator 
        ? (
          <Rooms
            rooms={rooms}
            selectRoomNumber={selectRoomCabinetNumber}
            onChooseRoom={onChooseRoom}
            onChooseAllRooms={onChooseAllRooms}
            allRoomsSelected={showAllRoomsMeetings}
            isLoading={roomsLoading}
          />
        )
        : (
          <PrivateCalendars
            calendars={privateCalendars}
            onCheckedCalendar={setCheckedCalendar}
            getHexCodefromColorName={getColorByName} 
            isLoading={isCalendarsLoading}
          />
        )
      }

    </>
  )
});
